export default __webpack_public_path__ + "f29913b9bfdbc29b355f86bd702cc8a2.png";